import { createFileRoute } from "@tanstack/react-router";
import { useQuery } from "@tanstack/react-query";
import { useServerFn } from "@tanstack/react-start";

import StoryExperience from "@/components/StoryExperience";
import { getCategoryTree } from "@/lib/categories.functions";

export const Route = createFileRoute("/c/$slug")({
  head: ({ params }) => {
    const pretty = params.slug
      .split("-")
      .map((s) => s.charAt(0).toUpperCase() + s.slice(1))
      .join(" ");
    const title = `${pretty} — Backland`;
    return {
      meta: [
        { title },
        { property: "og:title", content: title },
      ],
    };
  },
  component: CategoryDeepLink,
});

function CategoryDeepLink() {
  const { slug } = Route.useParams();
  const fetchTree = useServerFn(getCategoryTree);
  const { data: tree } = useQuery({
    queryKey: ["category-tree"],
    queryFn: () => fetchTree(),
    staleTime: 60_000,
  });

  if (!tree) {
    return <div className="fixed inset-0 bg-background" />;
  }

  const match = tree.categories.find((c) => c.slug === slug);
  if (!match) {
    return <StoryExperience />;
  }
  return <StoryExperience initialCategorySlug={slug} />;
}


